/* ==========================================================================
   SABR — splash hero film
   The master is 16:9; a phone crops it to the middle third, which is empty
   court in half the shots. So phones get their own 9:16 cut, framed on the
   garment prints, and hero.js hands the right file to the one <video>.
   Reduced motion gets neither — the still underneath shows through.
   ========================================================================== */

(function () {
  var video = document.querySelector('.splash__video');
  if (!video) return;

  var wide = window.matchMedia('(min-width: 701px)');
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');

  function wanted() {
    if (!wide.matches && video.dataset.srcMobile) return video.dataset.srcMobile;
    return video.dataset.src;
  }

  function attach() {
    if (still.matches) return;
    var src = wanted();
    if (!src) return;
    if (video.getAttribute('src') === src) return;

    video.setAttribute('src', src);
    video.load();
    // Autoplay can still be refused (low power mode, data saver). The still
    // behind the video stays up on its own, so a rejection needs no handling.
    var played = video.play();
    if (played && played.catch) played.catch(function () {});
  }

  attach();
  // Rotating a phone into landscape should swap up to the wide cut.
  if (wide.addEventListener) wide.addEventListener('change', attach);
  else if (wide.addListener) wide.addListener(attach);
})();
